/**************************************************
 * Nombre:       Formulario_Programa_Perfil_Perfil
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";

const Formulario_Programa_Perfil_Perfil = ({...props}) => {


    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto nombre={'Titulo de parrafo Perfil'}
                                  dato={'nombre'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto lineas={5} nombre={'Parrafo perfil'}
                                  dato={'descripcion'} {...props}
                                  requerido={'Campo requerido'}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Programa_Perfil_Perfil